<p-dropdown
  [options]="etablissements"
  [(ngModel)]="selectedEtablissement"
  optionLabel="Nom"
  placeholder="Sélectionner un établissement"
  id="etablissement"
  name="etablissement"
  class="dropdown-etablissement"
  scrollHeight="400px"
  (onChange)="etablissementChanged()"
  [filter]="true"
  emptyFilterMessage="Aucun établissement trouvé"
  [readonly]="etablissementIsLocked"
>
  <ng-template pTemplate="selectedItem">
    <table *ngIf="selectedEtablissement" class="table-etablissement-item-value">
      <tr>
        <td class="td-etablissement-item-value"><img src="{{ selectedEtablissement.LogoUrl }}" class="selected-item-img-etablissement" /></td>
      </tr>
    </table>
  </ng-template>
  <ng-template let-etablissement pTemplate="item">
    <table>
      <tr>
        <td class="td-etablissement-img"><img src="{{ etablissement.LogoUrl }}" class="etablissement-item-img" /></td>
        <td class="td-etablissement-nom">{{ etablissement.Nom }}</td>
      </tr>
    </table>
  </ng-template>
</p-dropdown>
